import { render, staticRenderFns } from "./JiraTab.vue?vue&type=template&id=b84b915a"
import script from "./JiraTab.vue?vue&type=script&lang=js"
export * from "./JiraTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports